// external imports
import React from 'react'
import PropTypes from 'prop-types'

class Marker extends React.Component {
    static contextTypes = {
        registerMarker: PropTypes.func
    }

    componentDidMount() {
        this.context.registerMarker(this.props)
    }

    render = () => null
}

export default Marker



// WEBPACK FOOTER //
// ./src/components/maps/Marker.js